import {CartService} from './CartService';
import {StyleSettingsService} from './StyleSettingsService';
import {SPECS} from '../specs';
import {ViewerContext} from '@wix/ecom-platform-storefront-common';
import {EcommerceSettingsService} from './EcommerceSettingsService';

export class OrderService {
  private readonly cartService: CartService;
  private readonly styleSettingsService: StyleSettingsService;
  private readonly viewerContext: ViewerContext;
  private readonly ecommerceSettingsService: EcommerceSettingsService;
  public destinationWasChanged: boolean = false;

  constructor({
    cartService,
    ecommerceSettingsService,
    styleSettingsService,
    viewerContext,
  }: {
    cartService: CartService;
    ecommerceSettingsService: EcommerceSettingsService;
    styleSettingsService: StyleSettingsService;
    viewerContext: ViewerContext;
  }) {
    this.cartService = cartService;
    this.styleSettingsService = styleSettingsService;
    this.viewerContext = viewerContext;
    this.ecommerceSettingsService = ecommerceSettingsService;
  }

  public get hasDeliveryOptions(): boolean {
    return !!this.cartService.deliverySectionModel?.options?.length;
  }

  public get canShip() {
    /* istanbul ignore next */
    return (
      this.hasDeliveryOptions ||
      //todo(guy segev): test delivery error for digital (cart.errors.cant_sell_to_country?)
      /* istanbul ignore next */
      this.cartService.isNonShippableCart ||
      /* istanbul ignore next */
      !this.destinationWasChanged
    );
  }

  public isPickup(): boolean {
    return this.cartService.cartSummary?.deliverySummary?.method?.pickup;
  }

  public get hasPickupOption(): boolean {
    return this.cartService.deliverySectionModel?.options.some((option) => option.isPickup);
  }

  public get hasDeliveryAddress(): boolean {
    return !!this.cartService.cartModel?.deliveryInfo?.address?.country;
  }

  public get shouldDisplayTax() {
    const {shouldShowTax} = this.styleSettingsService;

    const isTaxConfigured = this.viewerContext.isExperimentEnabled(SPECS.MoveCartToViewerContext)
      ? this.ecommerceSettingsService.getEcommerceSettings().isTaxConfigured
      : true;

    return isTaxConfigured && shouldShowTax && !this.cartService.cartModel.taxInfo.pricesIncludeTax;
  }

  public get minimumOrderAmount() {
    return this.cartService.cartSummary?.minimumOrderAmount;
  }

  public get hasShippingDestination() {
    return (
      this.hasDeliveryAddress &&
      (this.cartService.deliverySectionModel?.canShipToDestination || this.destinationWasChanged)
    );
  }
}
